module.exports = __webpack_public_path__ + "img/NationalTechnicalInventionAward.e06470ac.jpg";